/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import Tick from "./Tick";

// this is for workflow

export default class CPTCodeSelectW extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            cptCodes: [],
            modCodes: [], 
            currentValues: []
        }
    }

    async componentDidMount() {
        await this.fillListAsync('/api/modcode/list', 'modCodes', true);
        this.setState({ currentValues: this.props.currentValues });
    }
    
    componentDidUpdate(prevProps) {
        if(this.props.currentValues !== prevProps.currentValues) {
            this.setState({ currentValues: this.props.currentValues });
        }
    }

    search = (e) => {
        if(!e.target.value) {
            this.setState({ cptCodes: [] });
            return;
        }
        qreq.post('/api/cptcode/list', { search: e.target.value }, j => {
            if(this.state.touched)
                return;
            if (j.list)
                this.setState({ cptCodes: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    change = (e) => {
        this.setState({ touched: true, search: e.target.value });
    }

    tick = () => {
        if (this.state.touched) {
            this.setState({ touched: false });
            this.search({ target: { value: this.state.search } });
        }
    }

    select(i) {
        let currentValues = [...this.state.currentValues];
        if (this.isSelected(i)) {
            currentValues = currentValues.filter(j => j.id !== i.id);
        } else {
            currentValues = currentValues ?? [];
            i.units = 1;
            currentValues.push(i);
        }
        this.setState({ currentValues });
        this.props.onChange?.(currentValues);
    }

    isSelected(i) {
        if (this.state.currentValues?.find(j => j.id === i.id))
            return true;
        return false;
    }

    toggleAddMod = (i) => {
        i.add = !i.add;
        this.setState({ currentValues: [...this.state.currentValues] });
        this.props.onChange?.(this.state.currentValues);
    }

    addModCode = (e, i) => {
        let find = i.modifiers?.find(j => j.id === parseInt(e.target.value));
        if(find) {
            i.add = false;
            this.props.onChange?.(this.state.currentValues);
            this.setState({ currentValues: [...this.state.currentValues] });
            return; // already added
        }
        let mod = this.state.modCodes.find(j => j.id === parseInt(e.target.value));
        if (mod) {
            i.modifiers = i.modifiers ?? [];
            i.modifiers.push(mod);
            i.add = false;
            this.props.onChange?.(this.state.currentValues);
        }
        this.setState({ currentValues: [...this.state.currentValues] });
    }

    removeModCode = (i, j) => {
        i.modifiers = i.modifiers.filter(a => a.id !== j.id);
        this.props.onChange?.(this.state.currentValues);
    }

    changeUnits = (i, e) => {
        i.units = e.target.value;
        this.props.onChange?.(this.state.currentValues);
    }

    render() {
        return <>
            <Tick interval={1000} onTick={this.tick} />
            {!this.props.disabled && <input type="text" className="form-control mb-3" placeholder="Search CPT code or description..." onChange={this.change} />}
            {this.state.currentValues?.length === 0 ? <div className="text-muted">
                {/* NL */}
            </div> : <table className="table">
                <thead>
                    <tr>
                        <th>CPT</th>
                        <th className="d-none d-md-table-cell" style={{width: '50%'}}>Description</th>
                        {!this.props.hideModifiers && <th>Modifiers</th>}
                        <th style={{width: '7rem'}}>Units</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                        {this.state.currentValues?.map((i, idx) => (
                            <tr key={idx}>
                                <td>
                                    {i.code}
                                </td>
                                <td className="d-none d-md-table-cell text-muted">{i.description}</td>
                                {!this.props.hideModifiers && <td>
                                    <span>
                                    {i.modifiers?.length === 0 && !i.add && <span className="text-muted">None</span>}
                                    {i.modifiers?.map((j, jdx) => (
                                        <span key={jdx} className="badge bg-secondary me-1 mb-1 no-select" title={j.description} data-tooltip-content={j.description}>
                                            {j.code} <Icon icon="faTimes" role="button" onClick={() => this.removeModCode(i, j)} />
                                        </span>
                                    ))}
                                    </span>
                                    {i.add && <div className="input-group">
                                        <select className="form-select" onChange={(e) => this.addModCode(e, i)}>
                                            <option value="">Select Modifier</option>
                                            {this.state.modCodes.map((j, jdx) => !i.modifiers?.find(a => a.id === j.id)
                                                && <option key={jdx} value={j.id}>{j.code} - {j.description}</option>)}
                                        </select>
                                    </div>}
                                    {!i.add
                                        && this.state.modCodes.length > i.modifiers.length
                                        && !this.props.disabled
                                        && <span role="button" className="btn ms-md-2" onClick={() => this.toggleAddMod(i)}><Icon icon="faPlus" /></span>}
                                </td>}
                                <td>
                                    <input value={i.units} type="number" className="form-control" placeholder="Units" onChange={(e) => this.changeUnits(i,e)} disabled={this.props.disabled} />
                                </td>
                                <td className="text-end">
                                    {!this.props.disabled && <button type="button" className="btn btn-close" onClick={() => this.select(i)}></button>}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>}
            {!this.props.disabled && this.state.cptCodes?.map((i, idx) => <div key={idx} className="border-bottom my-2">
                <div className="row align-items-center">
                    <div className="col-3 col-md-2 col-lg-2">
                        <button type="button" className={'btn w-100 ' + (this.isSelected(i) ? 'btn-success' : 'btn-primary')} onClick={() => this.select(i)}>{i.code}</button>
                    </div>
                    <div className="col-9 col-md-10 col-lg-10">
                        {i.description}
                    </div>
                </div>
            </div>)}
        </>;
    }
}